/* unplugin-vue-components disabled */import script from "./ProfileDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileDialog.vue?vue&type=script&setup=true&lang=js"

import "./ProfileDialog.vue?vue&type=style&index=0&id=5a2c7c44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a2c7c44"]])

export default __exports__